<template>
	<div class="fieldsBlock">
		<div class="fieldsBlock_title">
			<span>Comments</span>
			<button type="button" class="commentsBtn" @click="onDrawer(true)">
				<span>Add new</span>
				<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
			</button>
		</div>
		<div class="fieldsBlock_body">
			<div class="groupField">
				<div v-if="comments.length" class="commentsBlock-wrap">
					<div class="commentsBlock head">
						<div class="commentsBlock-item">Date created</div>
						<div class="commentsBlock-item">Created by</div>
						<div class="commentsBlock-item">Note</div>
					</div>
					<template v-for="({ date, comment, id, created_name }, idx) in comments">
						<div class="commentsBlock" :key="idx">
							<div class="commentsBlock-item">{{ date }}</div>
							<div class="commentsBlock-item">{{ created_name }}</div>
							<div class="commentsBlock-item">{{ comment }}</div>
							<button
									:disabled="created_name !== name"
									type="button"
									class="btnIcon"
									@click="onEditItem(idx, id)"
							>
								<svg-sprite height="20" width="20" icon-id="edit"></svg-sprite>
							</button>
							<button
									:disabled="created_name !== name"
									type="button"
									class="btnIcon"
									@click="onDeleteItem(idx, id)"
							>
								<svg-sprite height="20" width="20" icon-id="deleteItem"></svg-sprite>
							</button>
						</div>
					</template>
					<div class="commentsBlock bottom">
						<div class="commentsBlock-item">n: <span>{{ comments.length }}</span></div>
						<div class="commentsBlock-item"></div>
						<div class="commentsBlock-item"></div>
						<div></div>
					</div>
				</div>
			</div>
		</div>
		<comments-drawer
				v-if="drawer"
				:editData="editData"
				:created_by="created_by"
				:name="name"
				@updateDrawer="onDrawer"
				@updateSave="onSave"
		></comments-drawer>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import CommentsDrawer from "@/components/Maintenance/PotentialClient/CommentsDrawer/CommentsDrawer";

export default {
	name: "CommentsTable",
	components: { CommentsDrawer },
	props: {
		comments: Array,
		created_by: Number,
		name: String
	},
	data: () => ({
		drawer: false,
		editData: null,
		idx: null
	}),
	methods: {
		...mapActions([ 'getWorkOrdersDelete' ]),
		onDrawer(value) {
			this.drawer = value;
			this.editData = null;
		},
		onSave(item) {
			if (this.editData) {
				this.comments.splice(this.idx, 1, item);
			} else {
				this.comments.push(item);
			}

			this.drawer = false;
			this.editData = null;
		},
		onDeleteItem(idx) {
			this.comments.splice(idx, 1);
		},
		onEditItem(idx) {
			this.idx = idx;
			this.drawer = true;
			this.editData = this.comments[idx];
		}
	}
};
</script>

<style scoped lang="scss">
@import "CommentsTable";
</style>
